import { axios } from '../../../services/axios';
import * as CONST from '../../constants';

const onSuccess = (dispatch, data) => {
  dispatch({ type: CONST.FOOD_CATEGORY_SHOW_SUCCESS, data: data });
};

const onFailed = (dispatch, error) => {
  dispatch({ type: CONST.FOOD_CATEGORY_SHOW_ERROR, error });
};

const handleResponse = (dispatch, response) => {
  if (response.status === 200) {
    onSuccess(dispatch, response.data);
  } else {
    onFailed(dispatch, response.data);
  }
};

export const foodCategoryShow = (id) => {
  return async (dispatch) => {
    dispatch({ type: CONST.FOOD_CATEGORY_SHOW_REQUEST });

    axios.get(`/food-categories/${id}`).then((response) => {
      handleResponse(dispatch, response);
    });
  };
};
